(function () {
  const BTN_SELECTOR = '.js-cartdrawer-add-3';

  function getRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function setLoading(btn, isLoading) {
    if (!btn) return;
    btn.disabled = isLoading;
    btn.classList.toggle('is-loading', isLoading);

    if (isLoading) {
      btn.dataset._oldText = btn.textContent;
      btn.textContent = btn.getAttribute('data-loading-text') || 'Adding...';
    } else if (btn.dataset._oldText) {
      btn.textContent = btn.dataset._oldText;
      delete btn.dataset._oldText;
    }
  }

  function build3ItemsFromButton(btn) {
    const items = [
      { id: Number(btn.dataset.v1), quantity: Number(btn.dataset.q1 || 1) },
      { id: Number(btn.dataset.v2), quantity: Number(btn.dataset.q2 || 1) },
      { id: Number(btn.dataset.v3), quantity: Number(btn.dataset.q3 || 1) },
    ].filter((item) => item.id && item.quantity > 0);

    if (items.length !== 3) {
      throw new Error('Please set data-v1/data-v2/data-v3 with 3 valid variant IDs and optional data-q1/q2/q3.');
    }

    return items;
  }

  async function fetchCart() {
    const root = getRoot();
    const res = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Failed to fetch cart.');
    return res.json();
  }

  async function addItemsAndReturnSections(items, options = {}) {
    const root = getRoot();
    const sectionsToRequest = options.sections || ['cart-drawer'];
    const properties =
      options.properties && typeof options.properties === 'object' ? options.properties : null;

    const payload = {
      items: items.map((item) => ({
        id: Number(item.id),
        quantity: Number(item.quantity) || 1,
        ...(properties ? { properties } : {}),
      })),
      sections: sectionsToRequest,
      sections_url: window.location.pathname,
    };

    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      let msg = 'Add to cart failed.';
      try {
        const err = await res.json();
        msg = err?.description || err?.message || msg;
      } catch (e) {
        msg = await res.text();
      }
      throw new Error(msg);
    }

    const parsedState = await res.json();

    if (!parsedState?.sections || !parsedState.sections['cart-drawer']) {
      console.warn("ATC response missing sections['cart-drawer']:", parsedState);
      throw new Error('Cart drawer sections were not returned.');
    }

    if (typeof parsedState.item_count === 'undefined') {
      const cart = await fetchCart();
      parsedState.item_count = cart.item_count;
      parsedState.id = cart.token || parsedState.id;
    }

    return parsedState;
  }

  function openDrawerFallback(triggerEl) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(triggerEl);
      return true;
    }
    return false;
  }

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest(BTN_SELECTOR);
    if (!btn) return;

    event.preventDefault();

    const drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      console.warn('cart-drawer element not found on page.');
      window.location.href = `${getRoot()}cart`;
      return;
    }

    try {
      setLoading(btn, true);

      let items = build3ItemsFromButton(btn);
      const skipIfInCart = btn.getAttribute('data-skip-if-in-cart') !== 'false';

      if (skipIfInCart) {
        const cart = await fetchCart();
        const inCart = new Set((cart.items || []).map((lineItem) => Number(lineItem.variant_id)));
        items = items.filter((item) => !inCart.has(Number(item.id)));
      }

      if (!items.length) {
        if (!openDrawerFallback(btn)) window.location.href = `${getRoot()}cart`;
        return;
      }

      const parsedState = await addItemsAndReturnSections(items, {
        sections: ['cart-drawer'],
        properties: { _source: 'cart_drawer_bundle' },
      });

      if (typeof drawer.renderContents === 'function') {
        drawer.renderContents(parsedState);
        window.SpeciesBoldUpsell?.emitCartLoaded?.();
      } else {
        window.location.href = `${getRoot()}cart`;
      }
    } catch (err) {
      console.error(err);
      alert(err?.message || 'Could not add items.');
    } finally {
      setLoading(btn, false);
    }
  });

  window.addThreeItemsCartDrawer = async function (v1, q1, v2, q2, v3, q3) {
    const drawer = document.querySelector('cart-drawer');
    const items = [
      { id: Number(v1), quantity: Number(q1) || 1 },
      { id: Number(v2), quantity: Number(q2) || 1 },
      { id: Number(v3), quantity: Number(q3) || 1 },
    ];

    const parsedState = await addItemsAndReturnSections(items, {
      sections: ['cart-drawer'],
      properties: { _source: 'cart_drawer_bundle' },
    });

    if (typeof drawer.renderContents === 'function') {
      drawer.renderContents(parsedState);
      window.SpeciesBoldUpsell?.emitCartLoaded?.();
      drawer.open();
    } else {
      window.location.href = `${getRoot()}cart`;
    }
  };
})();
